<template>
    <header id="top">
        <div class="container-fluid">
            <div class="logo">
                <router-link :to="{name: 'expedient.index'}" id="logo-link">
                    <img src="/images/logo-peitho.jpg" alt="Logo Empresa">
                </router-link>
            </div>

            <the-menu></the-menu>

            <div class="top-item--profile">
                <div class="dropdown dropdown-menu-right dropdown-user">
                    <button class="btn btn-primary dropdown-toggle" type="button"
                            aria-labelledby="headerDropdownMenuButton" id="user-header-dropdown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ user.name }}
                    </button>

                    <div class="dropdown-menu" id="headerDropdownMenuButton">
                        <form action="/logout" method="POST">
                            <input type="hidden" name="_token" :value="_csrf_token">

                            <button type="submit" class="dropdown-item logout" id="logout-button">
                                <span>Cerrar Sesión</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import TheMenu from "./TheMenu";

export default {
    name: "TheHeader",
    components: {TheMenu},
    methods: {
        logout() {
            this.$refs.logoutForm.submit();
        },
        can() {
            return true;
        }
    },
    inject: ['_csrf_token', '_user_token'],
    data() {
        return {
            userRol: null,
        }
    },
    computed: {
        user() {
            return window.user;
        }
    },
}
</script>
